/* Vellisova: dependency-free cart. One authoritative write at a time. */
(() => {
  'use strict';
  const root = document.getElementById('v-cart-root');
  if (!root || window.VCart) return;
  const $ = (s, el = root) => el.querySelector(s);
  const base = window.Shopify?.routes?.root || '/';
  let cart = JSON.parse(document.getElementById('v-cart-initial').textContent);
  let busy = false, lastFocus, blocked = [];
  const currency = () => cart.currency || window.Shopify?.currency?.active || 'USD';
  const money = n => new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency', currency: currency()
  }).format(Number(n || 0) / 100);
  const status = message => { $('[data-cart-status]').textContent = message; };
  function render(c) {
    if (!Array.isArray(c.items)) throw new Error('Cart could not be loaded.');
    cart = c;
    $('[data-cart-count]').textContent = c.item_count;
    document.querySelectorAll('.cart span').forEach(n => n.textContent = `Cart (${c.item_count})`);
    $('[data-cart-empty]').hidden = !!c.item_count;
    $('[data-cart-items]').hidden = !c.item_count;
    $('[data-cart-foot]').hidden = !c.item_count;
    $('[data-cart-subtotal]').textContent = money(c.total_price);
    const discounts = $('[data-cart-discounts]');
    discounts.replaceChildren();
    discounts.hidden = !(c.cart_level_discount_applications || []).length;
    (c.cart_level_discount_applications || []).forEach(entry => {
      const d = entry.discount_application || entry;
      const row = document.createElement('p');
      const label = d.value_type === 'percentage' ? `Discount (${Number(d.value)}%)` : (d.title || 'Discount');
      row.textContent = `${label}: −${money(entry.amount ?? d.total_allocated_amount)}`;
      discounts.appendChild(row);
    });
    const list = $('[data-cart-items]');
    const fragment = document.createDocumentFragment();
    c.items.forEach(it => {
      const node = document.getElementById('v-cart-item-tpl').content.firstElementChild.cloneNode(true);
      node.dataset.lineKey = it.key;
      const title = $('.v-cart-item__title', node);
      title.textContent = it.product_title;
      title.href = it.url;
      $('.v-cart-item__img', node).href = it.url;
      const image = $('img', node);
      if (it.image) {
        const url = new URL(it.image, location.origin);
        url.searchParams.set('width', '160');
        image.src = url.href;
      } else image.hidden = true;
      image.alt = it.product_title;
      image.loading = 'eager';
      image.width = 72; image.height = 72;
      const opts = (it.options_with_values || []).filter(o => o.value !== 'Default Title').map(o => o.value);
      Object.entries(it.properties || {}).filter(([k,v]) => v && !k.startsWith('_')).forEach(([k,v]) => opts.push(`${k}: ${v}`));
      (it.line_level_discount_allocations || []).forEach(d => opts.push(d.discount_application.title));
      $('.v-cart-item__opts', node).textContent = opts.join(' · ');
      $('[data-qty-input]', node).value = it.quantity;
      $('[data-line-price]', node).textContent = money(it.final_line_price);
      fragment.appendChild(node);
    });
    list.replaceChildren(fragment);
  }
  function open() {
    if (!root.classList.contains('is-open')) {
      lastFocus = document.activeElement;
      root.setAttribute('aria-hidden', 'false');
      root.classList.add('is-open');
      document.documentElement.classList.add('v-scroll-lock');
      blocked = [...document.body.children].filter(n => n !== root && !['SCRIPT','TEMPLATE'].includes(n.tagName) && !n.inert);
      blocked.forEach(n => n.inert = true);
      $('.v-cart__close').focus();
    }
  }
  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('v-scroll-lock');
    blocked.forEach(n => n.inert = false);
    blocked = [];
    if (lastFocus?.isConnected) lastFocus.focus();
  }
  function setBusy(value) {
    busy = value;
    root.setAttribute('aria-busy', String(value));
    root.querySelectorAll('[data-qty-inc],[data-qty-dec],[data-qty-input],[data-line-remove],[data-cart-checkout]').forEach(n => n.disabled = value);
    document.querySelectorAll('form[action*="/cart/add"] button[type="submit"]').forEach(n => {
      if (value && !n.disabled) { n.dataset.cartBusy = '1'; n.disabled = true; }
      if (!value && n.dataset.cartBusy) { n.disabled = false; delete n.dataset.cartBusy; }
    });
  }
  async function request(path, options = {}) {
    const response = await fetch(base + path, {credentials:'same-origin', cache:'no-store', ...options});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Unable to update your cart. Please retry.');
    return data;
  }
  async function refresh() {
    if (busy) return;
    try { render(await request('cart.js')); } catch (err) { status(err.message); }
  }
  async function write(path, body, isAdd = false) {
    if (busy) return;
    setBusy(true);
    status(isAdd ? 'Adding to your cart…' : 'Updating your cart…');
    try {
      const options = body instanceof FormData
        ? {method:'POST',body}
        : {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)};
      const result = await request(path, options);
      render(isAdd ? await request('cart.js') : result);
      status(isAdd ? 'Added to your cart.' : 'Cart updated.');
    } catch (err) {
      status(err.message);
      try { render(await request('cart.js')); } catch (_) { /* Keep last confirmed state. */ }
    } finally { setBusy(false); }
  }
  function add(form) {
    if (busy || !form.reportValidity()) return;
    const data = new FormData(form);
    data.delete('return_to');
    open();
    return write('cart/add.js', data, true);
  }
  document.addEventListener('submit', e => {
    if (e.target.matches('form[action*="/cart/add"]')) {
      e.preventDefault(); add(e.target);
    }
  });
  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-cart-open],a.cart');
    if (opener) { e.preventDefault(); status(''); open(); refresh(); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); close(); return; }
    if (e.target.closest('[data-cart-checkout]') && !busy) { location.assign(base + 'checkout'); return; }
    const control = e.target.closest('[data-qty-inc],[data-qty-dec],[data-line-remove]');
    if (control && !busy) {
      const line = control.closest('[data-line-key]');
      const current = cart.items.find(it => it.key === line.dataset.lineKey);
      const quantity = control.matches('[data-line-remove]') ? 0 : Math.max(0,current.quantity + (control.matches('[data-qty-inc]') ? 1 : -1));
      write('cart/change.js', {id:current.key,quantity});
    }
    const toggle = e.target.closest('.mobile-toggle');
    if (toggle) {
      const expanded = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.setAttribute('aria-label', expanded ? 'Close menu' : 'Open menu');
      document.querySelector('.nav').classList.toggle('is-open', expanded);
    }
  });
  document.addEventListener('change', e => {
    if (!e.target.matches('[data-qty-input]')) return;
    const q = Number(e.target.value);
    if (!Number.isInteger(q) || q < 0) { status('Enter a whole quantity of zero or more.'); render(cart); return; }
    write('cart/change.js', {id:e.target.closest('[data-line-key]').dataset.lineKey,quantity:q});
  });
  document.addEventListener('keydown', e => {
    if (!root.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      const controls = [...root.querySelectorAll('a[href],button:not(:disabled),input:not(:disabled)')].filter(n => n.getClientRects().length);
      const first = controls[0], last = controls[controls.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  render(cart);
  window.VCart = {open,close,refresh,add};
  if (document.body.classList.contains('template-cart')) open();
})();
